export default "__VITE_ASSET__C_o_t0rm__"